<script setup lang="ts">
/**
 * Plain text trail of the assistant's real tool calls — ".. {label} — {summary}".
 * Shown live while streaming and left in place above the finished answer so the
 * user can see what was actually queried. No animation by design.
 */
import type { ToolActivityStep } from "@/composables/useChatStream";

defineProps<{ steps: ToolActivityStep[] }>();
</script>

<template>
  <ul v-if="steps.length" class="mb-2 space-y-0.5 text-sm text-gray-500 dark:text-gray-400">
    <li v-for="step in steps" :key="step.id">
      <span class="text-gray-400 dark:text-gray-500">..</span>
      {{ step.label }}<span v-if="step.summary"> — {{ step.summary }}</span>
    </li>
  </ul>
</template>
